import { GridRendererProvider } from "../../data-grid/grid-renderer-provider.interface";
import { CellRendererItem } from "../../data-grid/cell-renderer-item";
import { FindReplaceService } from "./find-replace.service";
import { DefaultGridRendererProvider } from "../../data-grid/default-grid-renderer-provider";
import { FindReplaceCellRendererComponent } from "./find-replace-cell-renderer.component";
import { HeaderRendererItem } from "../../data-grid/header-renderer-item";
import { FindReplaceHeaderRendererComponent } from "./find-replace-header-renderer.component";

export class FindReplaceRendererProvider implements GridRendererProvider {
  private defaultProvider = new DefaultGridRendererProvider();
  private cellRenderer: CellRendererItem = new CellRendererItem(FindReplaceCellRendererComponent);
  private headerRenderer: HeaderRendererItem = new HeaderRendererItem(FindReplaceHeaderRendererComponent);

  constructor(private service: FindReplaceService) {}

  public getRowNumberHeaderRenderer(): HeaderRendererItem | null {
    return null;
  }

  getCellRenderer(colId: string): CellRendererItem {
    return this.service.columnId === colId ? this.cellRenderer : this.defaultProvider.getCellRenderer(colId);
  }

  getHeaderRenderer(colId: string): HeaderRendererItem {
    return this.headerRenderer;
  }

  getHeaderHeight(): number {
    return this.defaultProvider.getHeaderHeight();
  }
}
